import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="loan-application-form-self-disclosure-household"
export default class extends Controller {
  static targets = ['maritalStatus', 'maritalTaxAssessmentContainer', 'maritalTaxAssessmentField', 'numberOfAdults'];
  cachedMaritalStatus = '';

  connect() {
    this.reevaluate();
  }

  reevaluate() {
    this.reevaluateShowMaritalTaxAssessment();
    this.reevaluateNumberOfAdults();
    this.cachedMaritalStatus = this.maritalStatusTarget.value;
  }

  reevaluateNumberOfAdults() {
    if (this.cachedMaritalStatus !== this.maritalStatusTarget.value) {
      if (['Divorced','Widowed', 'Unmarried'].includes(this.maritalStatusTarget.value)) {
        Array.from(this.numberOfAdultsTarget.children).forEach(element => {
          if (element.value === '1') {
            element.selected = 'selected'
          } else {
            element.selected = null
          }
        })
      } else {
        Array.from(this.numberOfAdultsTarget.children).forEach(element => {
          if (element.value === '2') {
            element.selected = 'selected'
          } else {
            element.selected = null
          }
        })
      }
    }
  }

  reevaluateShowMaritalTaxAssessment() {
    if (!['Divorced','Widowed', 'Unmarried'].includes(this.maritalStatusTarget.value)) {
      this.maritalTaxAssessmentContainerTarget.classList.remove('is-hidden');
      this.maritalTaxAssessmentContainerTarget.classList.add('presence-validated');
    } else {
      this.maritalTaxAssessmentContainerTarget.classList.add('is-hidden');
      this.maritalTaxAssessmentContainerTarget.classList.remove('presence-validated');
      this.maritalTaxAssessmentFieldTarget.value = '';
      Array.from(this.maritalTaxAssessmentFieldTarget.children).forEach(element => {
        element.selected = null
      })
    }
  }
}
